import { Filter, FilterTypes } from 'components/FilterDrawer/FilterDrawer.config'
import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import { ITableColumnsType } from 'uikit/tables/default'
import columns from '../../UI/VerticalTable/columns'

export const filtersInitialState: Filter[] = [
  {
    type: FilterTypes.CHIPS,
    name: 'overviewDetails.industry',
    label: 'Industry',
    value: [],
  },
  {
    type: FilterTypes.CHIPS,
    name: 'entityDetails.location',
    label: 'Headquarters Location',
    value: [],
  },
  {
    type: FilterTypes.CHIPS,
    name: 'totals.jurisdictions',
    label: 'Jurisdictions',
    value: [],
  },
  {
    type: FilterTypes.CHIPS,
    name: 'totals.localDepartments',
    label: 'Local Departments',
    value: [],
  },
  {
    type: FilterTypes.SELECT,
    name: 'overviewDetails.registrationStatus',
    label: 'Registry Status',
    value: [],
  },
  {
    type: FilterTypes.CHIPS,
    name: 'overviewDetails.missingRegistries',
    label: 'Missing Registries',
    value: [],
  },
]

export const nexusColumns: ITableColumnsType<any> = [
  { ...columns[COLUMNS_IDS.verifiedName], fixed: 'left' as const, minWidth: 155, title: 'Business Name' },
  columns[COLUMNS_IDS.companyIndustry],
  columns[COLUMNS_IDS.companyFounded],
  { ...columns[COLUMNS_IDS.locations], title: 'Main Site' },
  columns[COLUMNS_IDS.companyLocations],
  columns[COLUMNS_IDS.registrationStatus],
  columns[COLUMNS_IDS.missingRegistries],
  columns[COLUMNS_IDS.companyEmployeesLocal],
  columns[COLUMNS_IDS.companyEmployeesAbroad],
  columns[COLUMNS_IDS.companyExecutivesLocal],
  columns[COLUMNS_IDS.companyExecutivesAbroad],
  columns[COLUMNS_IDS.nonRnDLocal],
  columns[COLUMNS_IDS.rndLocal],
  columns[COLUMNS_IDS.localDepartments],
  columns[COLUMNS_IDS.dataSources],
  columns[COLUMNS_IDS.entityType],
  columns[COLUMNS_IDS.caseId],
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  nexusColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
